
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#007F32","d":"M16.001 18.018a1.997 1.997 0 01-1.425-.592L.592 3.442A2.017 2.017 0 113.445.589l13.984 13.984a2.017 2.017 0 01-1.428 3.445zM2.017 32a2.017 2.017 0 01-1.425-3.445l13.984-13.984a2.017 2.017 0 112.853 2.853L3.445 31.408A2.013 2.013 0 012.017 32z"}})])
          )
        }
      }
    